export const data = [
  {
    author: {
      name: "Blic",
      score: 3,
      photo: "https://ocdn.eu/blic/static/share_image.jpg",
    },
    title: '"NEĆU DA IMPLEMENTIRAM ČLANSTVO U UN" Vučić o evropskom planu za Kosovo: Hoću normalizaciju, ne stidim se toga, ali ovo NEĆU DA POTPIŠEM',
    content: [
      {
        title: '',
        text: "Važno je da ljudima u Srbiji kažem šta je to šta radimo i šta se zbiva proteklih nekoliko meseci. Ovo nije pitanje jednog člana, jednog papira i jednog sastanka. Juče smo razgovarali, nismo se dogovorili, biće još razgovora. Neću pristati da implementiram članstvo u UN niti da priznam nezavisnost, rekao je večeras predsednik Srbije Aleksandar Vučić.",
      },
      {
        title: '',
        text: 'Nije bilo mogućnosti za pregovore, bilo je uzmite ili ostavite - rekao je Vučić i nastavio: - Morate da razmišljate šta su posledice, a one su jasne, direktno odbijanje plana posledice su zaustavljanje EU integracija, a to znači prestanak daljih investicija, direktno povlačenje investicija, a nama samo u fabrikama gde su Nemci vlasnici radi 80.000 ljudi. Onda dolazi treća stvar, niz sveobuhvatih mera, koje bi značile ubi naša zemlja ostala izolovana od sveta - pojasnio je Vučić i dodao: ',
      },
      {
        title: 'O posledicama odbijanja plana ',
        text: 'Nije bilo mogućnosti za pregovore, bilo je uzmite ili ostavite - rekao je Vučić i nastavio: - Morate da razmišljate šta su posledice, a one su jasne, direktno odbijanje plana posledice su zaustavljanje EU integracija, a to znači prestanak daljih investicija, direktno povlačenje investicija, a nama samo u fabrikama gde su Nemci vlasnici radi 80.000 ljudi. Onda dolazi treća stvar, niz sveobuhvatih mera, koje bi značile ubi naša zemlja ostala izolovana od sveta - pojasnio je Vučić i dodao: ',
      },
      {
        text: 'Kažu ljudi da mi nismo reagovali i da nismo uputili primedbe i da smo sa svim saglasni, ja sad moram da vam pokažem naš odgovor na šest stranica. Naš non pejper, naš odgovor je vrlo temeljan, oštar i zasnovan na međunarodnom pravu. Dakle, to je predato međunarodnim predstavnicima, neki su vratili uz kozmetičke izmene i rekli "ovo uzimate ili ne uzimate".',
      },
      {
        text: 'Ja saopštavam precizno, vodim računa o svakom slovu, da je Srbija spremna da radi na implementaciji mnogih stvari iz plana, ali smo izneli jasnu veliku jednu primedbu. To sam rekao i Makronu i Šolcu u Minhenu, i svih velikim liderima. Reč je o tome da ne može da se priča o međusobnom priznanju, i ulasku Kosova u UN - rekao je on.'
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      },
      {
        title: 'O francusko-nemačkom planu',
        text: 'ovoreći o situaciji sa francusko-nemačkim planom, Vučić je rekao:- Svi kažu "pogledajte kakav je ovo užasan plan". Niko se nije setio da kaže da je Vučić ovo sve pročitao. Kažu ako nije potpisao, potpisaće, izdajnik, ako ne sad onda narednih meseci. Ne prija mi ništa što sam tamo čuo. Mene čudi kako se svi pravite naivni, kao da ne znate da se oni iz međunarodne zajednice zalažu za nezavisno Kosovo, da će da nam kažu “Kosovo je srce Srbije” - rekao je Vučić. On je naglasio da su šanse da se nešto promeni “nikakve”.'
      },
      {
        text: '- Hajde onda da pravimo mapu puta, o tome se razgovara, da dogovorimo šta implementiramo, neću da implementiram UN i članstvo u UN. Pravimo implementacioni plan, Lajčak dolazi pa ćemo nešto da predložimo. O svemu drugom sam spreman da razgovaram, hoću normalizaciju, ne stidim se toga, ali ovo neću da potpišem - rekao je Vučić i dodao da će plan da drže kao svoj okvir za pregovaračke procese.'
      },
      {
        text: ' - A moje rešenje je implementacija, ali ja neću da učestvujem u implementaciji nekih stvari iz tih 11 članova. Lajčaku, Šolcu, Makronu, Borelju ja sam rekao, a evo i sad vama, dok sam predsednik Republike Srbije neću prihvatiti ni potpisati ni formalno ni neformalno priznanje nezavnosti Kosova, ni ulazak u Ujedinjene nacije - pojasnio je predsednik Srbije. On je dodao da Borelj dolazi u Severnu Makedoniju 18. marta, ali da to nije nikakav rok.'
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      },
      {
        text: '- Evropski savet zaseda 24. marta, tamo će da kažu šta mi radimo. Ako ne radimo dovoljno neće da nam otvore neke klastere. Pritisaka će biti, naravno, i niko neće pustiti da razgovori traju u nedogled, ali do sada su trajali u nedogled - kazao je predsednik.'
      },
      {
        title: 'O ZSO',
        text: 'Vučić je rekao da je formiranje ZSO najvažnija stvar, a onda podsetio da o ZSO postoje četiri sporazuma. - Jedan je osnovni sporazum iz 2013. godine, drugi je mandat upravljačkog tima, treći plan implementacije, i četvrti je prvi sporazum o principima. Osim nadležnosti ZSO, kao što su jačanje demokratije, primarne i sekundarne zdravstvene zaštite, uslova za povratnike, istraživatčke aktivnosti, takođe može da promoviše i da predstavlja zajedničke interese članova ZSO, i predstavlja ih ispred vlasti u Prištini - dakle da čini i obavlja javne usluge, monitoring nad sprovođenjem svojih ciljeva, i druge nadležnosti. Sastoji se od skupštine, predsednika, saveta, odbora i administracije. Imaju prava da poseduju svoju pokretnu i nepokretnu imovinu, da imaju kompanije, zastavu, grb. Odluke se donose dvotrećinskom većinom - rekao je on. Predsednik je rekao da tačka 16 principa iz 2015. godine govori o nečemu što je od presudnog značaja. '
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      },
      {
        text: 'Ja kažem da nemam šta da krijem, ovo nam je postavljeno: "Ili hoćete ili nećete". Boreljova izjava je vrlo neodređena, ja sam govorio o konceptu ili okviru. Spremni smo da razgovaramo o svim temama, i to bi dovelo do normalizacije. Da, nama je potrebna normalizacija sa Albancima. Ali to nema veze sa najvažnijim državnim pitanjima, kako je predstavljeno u parlamentu, sa onim nasilnim predstavama u Skupštini, banerima, napadima, snajperskim puškama. Do toga da ću potpisati, a onda nisam potpisao - rekao je predsednik.'
      }
    ],
    theme: {
        background: "#0d4b53",
        titleColor: "#fbc057",
        color: "#fff",
        font: "'Source Sans Pro', sans-serif"
    }
  },
  {
    author: {
      name: "Buka",
      score: 3.5,
      photo: "https://6yka.com/svg/buka-radio-logo.svg",
    },
    title:
      "Ozren Perduv za BUKU o pretresima u Banjaluci: Nemamo povjerenje u MUP RS",
    content: [
      {
        text: "Mediji su objavili da je u toku pretres na više lokacija u Banjaluci vezano za slučaj Dragičević.",
      },
      {
        text: '"Mi ništa ne znamo, saznali smo sad iz medija, imamo pomalo nevjericu jer je u pretrese uključen MUP RS. Mi nemamo povjerenje u MUP RS i smatramo da druge policijske agencije pretrese mogu obavljati, brz učešća MUP-a RS... ',
      }
    ],
    theme: {
        background: "#0d0d0d",
        color: "#fff",
        titleColor: '#b77de0',
        font: "'Roboto Mono', monospace"   
    }
  },
  {
    author: {
      name: "Xymenes Gomar",
      score: 4.2,
      image: "http://dummyimage.com/198x100.png/5fa2dd/ffffff",
    },
    title: "Hajrija Čobo, aktivistkinja iz Kaknja za BUKU: Zbog rudnika hoće da nam unište rijeku koju pijemo",
    content: [
      {
        text: "priv slajd",
      },
      {
        text: "drugi slajd",
      },
      {
        text: "treci slajd",
      },
      {
        text: "cetvrti slajd",
      },
    ],
    theme: {
        background: "#a1734f",
        color: "#fff",
        titleColor: "#edcdb5",
        font: "'Teko', sans-serif"
    }
  },
  {
    author: {
      name: "Pavla Sutherel",
      score: 4.7,
      photo: "http://dummyimage.com/203x100.png/cc0000/ffffff",
    },
    title: "malesuada in imperdiet et",
    content: [
      {
        text: "priv slajd",
      },
      {
        text: "drugi slajd",
      },
      {
        text: "treci slajd",
      },
      {
        text: "cetvrti slajd",
      },
    ],
    theme: {
        background: "green",
        color: "white"   
    }
  },
  {
    author: {
      name: "Dimitrije Glibic",
      score: 4.6,
      photo: "logo192.png",
    },
    title: "Naslov prvog tekst",
    content: [
      {
        text: "priv slajd",
      },
      {
        text: "drugi slajd",
      },
      {
        text: "treci slajd",
      },
      {
        text: "cetvrti slajd",
      },
    ],
    theme: {
        background: "#848e65",
        color: "#3d3c43",
        titleColor: "#fff",
        font: "'Roboto Mono', monospace"   
    }
  },
  {
    author: {
      name: "Dimitrije Glibic",
      score: 4.6,
      photo: "logo192.png",
    },
    title: "Naslov drugog tekst",
    content: [
      {
        text: "priv slajd",
      },
      {
        text: "drugi slajd",
      },
      {
        text: "treci slajd",
      },
      {
        text: "cetvrti slajd",
      },
    ],
    theme: {
        background: "black",
        color: "yellow"   
    }
  },
];
